import { Box, Divider, Tab, Tabs, styled } from '@mui/material';
import Brands from '../StoreManagment/Brands';
import theme from '../../theme';

const StyledTabs = styled(Tabs)({
  '& .MuiTabs-indicator': {
    display: 'none',
  },
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 400,
    fontSize: '16px',
    color: 'text.secondary',
    '&.Mui-selected': {
      color: theme.palette.custom.textBlue,
      fontWeight: 500,
      backgroundColor: theme.palette.custom.sidebarActiveBg,
      borderRadius: '6px',
    },
  },
});

interface TabPanelProps {
  children: React.ReactNode;
  value: number;
  index: number;
}

const TabPanel = ({ children, value, index }: TabPanelProps) => {
  return value === index ? <>{children}</> : null;
};

interface BrandManagmentTabsProps {
  selectedTab: number;
  setSelectedTab: (value: number) => void;
  brandsList: any[];
  brandsListLoading?: boolean;
  onEditBrand: (brand: any) => void;
  onBrandSelect?: (brand: any) => void;
  onDeleteBrand: (brand: any) => Promise<void>;
  brandsListError?: any;
  isBrandsListError?: boolean;
  deletePending: boolean;
}

const BrandManagmentTabs = ({
  selectedTab,
  setSelectedTab,
  brandsList,
  brandsListLoading,
  onEditBrand,
  onBrandSelect,
  onDeleteBrand,
  brandsListError,
  isBrandsListError,
  deletePending,
}: BrandManagmentTabsProps) => {
  const tabItems = [
    {
      label: 'Brands',
      component: (
        <Brands
          brandsList={brandsList || []}
          brandsListLoading={brandsListLoading}
          onEditBrand={onEditBrand}
          onBrandSelect={onBrandSelect}
          onDeleteBrand={onDeleteBrand}
          brandsListError={brandsListError}
          isBrandsListError={isBrandsListError}
          deletePending={deletePending}
        />
      ),
    },
    // You can add more tabs here in the future as needed
  ];

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        backgroundColor: '#FFF',
        borderRadius: '8px',
        border: '1px solid #DCE0E7',
      }}
    >
      <Box sx={{ padding: '10px 16px' }}>
        <StyledTabs value={selectedTab} onChange={handleTabChange}>
          {tabItems.map((tab, i) => (
            <Tab key={i} label={tab.label} />
          ))}
        </StyledTabs>
      </Box>
      <Divider />
      <Box
        sx={{
          flexGrow: 1,
          overflow: 'auto',
          '&::-webkit-scrollbar': { display: 'none' },
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
        }}
      >
        {tabItems.map((tab, index) => (
          <TabPanel key={index} value={selectedTab} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};

export default BrandManagmentTabs;
